export const WIDGET_ROOT_ID = 'handiscover-accessibility-widget'

export type WidgetRoot = {
  // the element the widget renders in
  container: HTMLElement;
  // the element with the widget attributes: companyId, propertyId, buildingAreaId
  credentials: HTMLElement;
  apiKey: string | null;
}

/**
 * The element the client site added for the widget. A page can have it twice (the snippet pasted twice),
 * the widget renders in the first one and takes its attributes from the first one with a companyId.
 * Null when the site has none.
 */
export const findWidgetRoot = (doc: Document): WidgetRoot | null => {
  const roots = Array.from(doc.querySelectorAll<HTMLElement>(`#${WIDGET_ROOT_ID}`))
  if (roots.length === 0) {
    return null
  }
  const credentials = roots.find((root) => root.getAttribute('companyId')) ?? roots[0]
  return {
    container: roots[0],
    credentials,
    apiKey: credentials.getAttribute('companyId'),
  }
}
